import invariant from 'tiny-invariant'
import * as Sentry from '@sentry/react'

const CF_URL = process.env.NEXT_PUBLIC_CF_URL || process.env.VITE_CF_URL
invariant(CF_URL, 'NEXT_PUBLIC_CF_URL inside nonce is required')

export enum NonceType {
  LOGOUT = 'customer-logout',
  REACTIVATE_SUBSCRIPTION = 'reactivate-subscription-action',
  UNDO_SUBSCRIPTION_CANCELLATION = 'undo_subscription_cancellation_nonce_field',
}

export interface NonceData {
  nonce: string
}

export async function nonceFetcher(nonceType: NonceType | string): Promise<NonceData> {
  const body = JSON.stringify({
    nonce: nonceType,
  })

  const headers = new Headers()

  headers.append('accept', 'application/json, multipart/mixed')
  headers.append('content-type', 'application/json')

  try {
    const res = await fetch(`${CF_URL}/cfsecure/nonce`, {
      method: 'POST',
      credentials: 'include',
      headers,
      body,
    })

    const textResponse = await res.text()

    try {
      const fetchData: NonceData = JSON.parse(textResponse)
      return fetchData
      // oxlint-disable-next-line unicorn/catch-error-name
    } catch (err) {
      throw new Error('Nonce response is not JSON')
    }
  } catch (error) {
    Sentry.captureException(
      new Error(
        `Error while fetching or parsing nonce:
          error = ${(error as Error)?.message ? (error as Error)?.message : (error as string)}`,
      ),
    )
    throw new Error('Failed to fetch nonce')
  }
}

export function useLogoutNonceGetter() {
  const getNonce = async () => {
    try {
      const response = await nonceFetcher(NonceType.LOGOUT)

      return response.nonce
      // oxlint-disable-next-line unicorn/catch-error-name
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  }

  return getNonce
}

export function useUndoCancelSubscriptionNonceGetter(subscriptionId: string) {
  const getNonce = async () => {
    try {
      const response = await nonceFetcher(`${NonceType.REACTIVATE_SUBSCRIPTION}-${subscriptionId}`)

      return response.nonce
      // oxlint-disable-next-line unicorn/catch-error-name
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  }
  return getNonce
}
